import { Options, Vue } from "vue-class-component";

@Options({
    name: "office-material-icon",
})
export default class OfficeMaterialIcon extends Vue {
}
